'use client';

import { c as _c } from "react/compiler-runtime";
import { Image as ImageIcon } from 'lucide-react';
import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import type { GameRecordDirectory } from '@/lib/games';
import { Card, CardContent } from '@/components/ui/card';
interface GamePreviewProps {
  game: GameRecordDirectory;
  className?: string;
}
export const GamePreview = t0 => {
  const $ = _c(16);
  const {
    game,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [thumbnailError, setThumbnailError] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setThumbnailError(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = game.metadata?.thumbnailUrl;
  let t4;
  if ($[1] !== t3) {
    t4 = [t3];
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  useEffect(t2, t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      console.log("GamePreview::handleImageError: Image failed to load.");
      setThumbnailError(true);
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleImageError = t5;
  const imageSrc = game.metadata?.thumbnailUrl?.startsWith("http") ? game.metadata.thumbnailUrl : null;
  const t6 = `w-full max-w-xs ${className}`;
  let t7;
  if ($[4] !== game.metadata?.name || $[5] !== imageSrc || $[6] !== thumbnailError) {
    t7 = <div className="w-full aspect-[4/3] overflow-hidden rounded-md border bg-gray-100 dark:bg-gray-800 relative">{imageSrc && !thumbnailError ? <Image src={imageSrc} alt={`${game.metadata?.name || "Game"} thumbnail`} fill={true} sizes="(max-width: 768px) 100vw, 200px" className="object-cover" onError={handleImageError} /> : <div className="h-full w-full flex items-center justify-center bg-gray-100 dark:bg-gray-800"><div className="flex flex-col items-center"><ImageIcon className="h-6 w-6 text-gray-400 mb-1" /><span className="text-xs text-gray-400">No thumbnail</span></div></div>}</div>;
    $[4] = game.metadata?.name;
    $[5] = imageSrc;
    $[6] = thumbnailError;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = game.metadata?.name || game.gameId;
  let t9;
  if ($[8] !== t8) {
    t9 = <div className="text-center"><h3 className="font-medium text-sm truncate">{t8}</h3></div>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t9) {
    t10 = <CardContent className="p-3"><div className="space-y-2">{t7}{t9}</div></CardContent>;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t6) {
    t11 = <Card className={t6}>{t10}</Card>;
    $[13] = t10;
    $[14] = t6;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
};
GamePreview.displayName = 'GamePreview';